// Returns the full Authorization header value with Bearer prefix (Cognito)
export function getAuthHeader() {
  var token = localStorage.getItem('primal_cognito_token');
  if (!token) return '';
  return 'Bearer ' + token;
}
